// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_35rgl2FkEe0P6zrKi-K21b"};